import EmployeeDataTypes from "../pages/hr/Types/EmployeeTypes"

const employeeBackground = {
    backgrounds:
        [
            { chars: ["a", "b", "c", "d", "e"], color: "#c849645c", fontColor: "#48000080", shadow: "2px 2px 2px rgba(200, 73, 100, 0.36)" },//red(kile)
            { chars: ["f", "g", "h", "i", "j"], color: "#bd49c859", fontColor: "#3d004878", shadow: "2px 2px 2px rgba(169, 73, 200, 0.46)" },//purple(beach)
            { chars: ["k", "l", "m", "n", "o", "p"], color: "#4956c875", fontColor: "#1b157fa6", shadow: "2px 2px 2px rgba(81, 73, 200, 0.43)" },//blue(johnson)
            { chars: ["q", "r", "s", "t", "u"], color: "#49c87a78", fontColor: "#1c5a297a", shadow: "2px 2px 2px rgba(73, 200, 122, 0.47)" },//green(hinrichs)
            { chars: ["v", "w", "x", "y", "z"], color: "#c8824969", fontColor: "#923f1f82", shadow: "2px 2px 2px rgba(200, 130, 73, 0.41)" },//orane(turley)
        ],
    getBackground: (employee?: EmployeeDataTypes | null) => {
        let bg = { color: "#16217a", fontColor: "#FFFFFF", firstInitial: "EL", lastInitial: "M", shadow: "2px 2px 2px rgba(22, 33, 122, 0.3)" }
        if (employee) {
            if (employee.FirstName && employee.LastName && employee.LastName.length >= 1 && isNaN(parseInt(employee.LastName))) {
                for (let i = 0; i < employeeBackground.backgrounds.length; i++) {
                    for (let j = 0; j < employeeBackground.backgrounds[i].chars.length; j++) {
                        if ((employee.LastName.charAt(employee.LastName.length - 1).toLowerCase() === employeeBackground.backgrounds[i].chars[j])) {
                            bg.color = employeeBackground.backgrounds[i].color
                            bg.fontColor = employeeBackground.backgrounds[i].fontColor
                            bg.firstInitial = employee.FirstName.charAt(0)
                            bg.lastInitial = employee.LastName.charAt(0)
                            bg.shadow = employeeBackground.backgrounds[i].shadow
                        }
                    }
                }
            } else if (employee.LastName && !isNaN(parseInt(employee.LastName))) {
                bg = { color: "#16217a", fontColor: "#FFFFFF", firstInitial: "DE", lastInitial: "V", shadow: "2px 2px 2px rgba(22, 33, 122, 0.3)" }
            } else {
                bg = { color: "#16217a", fontColor: "#FFFFFF", firstInitial: "EL", lastInitial: "M", shadow: "2px 2px 2px rgba(22, 33, 122, 0.3)" }
            }
        }
        return bg
    }
}

export default employeeBackground